









































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
// import 'assets/css/style.css';

@Component
export default class App extends Vue {

    @Prop() private msg!: string;
    private discount: number = 20;

    public distance: number = 0;
    public distanceCountry: number = 0;
    public time: number = 0;
    public classAuto: string = 'business';
    public minimal: number = 0;
    public result: number = 0;
    public resultDiscount: number = 0;

    public tariffs = {
        business: {
            base:            275, // Начальная стоиомость
            time:            22,  // Стоимость за минуту поездки
            distance:        22,  // Стоимость за 1км поездки (в городе)
            distanceCountry: 32,  // Стоимость за 1км поездки (за городом)
            min:             500  // Минимальная стоимость
        },
        vip:      {
            base:            500,
            time:            40,
            distance:        40,
            distanceCountry: 60,
            min:             1000
        },
        luxe:     {
            base:            550,
            time:            45,
            distance:        45,
            distanceCountry: 65,
            min:             2000
        },
        plus:     {
            base:            375,
            time:            30,
            distance:        30,
            distanceCountry: 45,
            min:             2500
        },
    };

    @Watch('distance')
    @Watch('distanceCountry')
    @Watch('time')
    @Watch('classAuto', {deep: true, immediate: true})
    onClassAutoChanged(val: string, oldVal: string): any {
        this.calc();
    }


    public calc(): any {
        let current = this.tariffs[this.classAuto];
        this.result = current.base
            + this.distance * current.distance
            + this.distanceCountry * current.distanceCountry
            + this.time * current.time;
        this.resultDiscount = this.result - (this.result * this.discount / 100);
        this.minimal = current.min;
    }

    mounted() {
        console.log('App mount');
    }

    created() {
        console.log('App created');
    }
}
